import Crud from "../Crud";
import { deepOrange } from "@mui/material/colors";

/**
 * Static helper functions related to Accounts.
 */
export default class UploadedFile extends Crud {
  /**
   * @param {object} uploadedFile The uploadedFile object.
   * @returns The display name of the uploadedFile.
   */
  static getDisplayName(uploadedFile) {
    return uploadedFile.filename;
  }

  /**
   * Determines if a uploadedFile matches a search query.
   *
   * @param {object} uploadedFile The uploadedFile to test.
   * @param {string} query The search query.
   * @returns {boolean} Whether or not the uploadedFile matches the query.
   */
  static match(uploadedFile, query) {
    return (
      (uploadedFile.filename !== null &&
        uploadedFile.filename.toLowerCase().includes(query)) ||
      uploadedFile.id === +query
    );
  }

  /**
   * @param {array} uploadedFiles The list to sort.
   * @returns {array} The sorted list.
   */
  static sort(uploadedFiles) {
    return uploadedFiles.sort((a, b) => {
      return new Date(b.uploadedAt) - new Date(a.uploadedAt);
    });
  }

  /**
   * @returns {string} The color of this object.
   */
  static getBaseColor() {
    return deepOrange;
  }

  /**
   * @returns {string} The icon name for this object.
   */
  static getIconName() {
    return "Feed";
  }

  /**
   * @param {object} uploadedFile The uploadedFile object.
   * @param {object} chart The chart object.
   * @returns {object} The activityFile object.
   */
  static getActivityFile(uploadedFile, chart) {
    return Object.values(chart.activityFile).find(
      (activityFile) => activityFile.fileId === uploadedFile.id,
    );
  }
}
